import React, { useCallback } from 'react';

interface Props {
  color?: string;
}

export const SearchIcon: React.FC<Props> = ({ color }) => {
  const renderColor = useCallback(() => {
    return color || '#000';
  }, [color]);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        stroke={renderColor()}
        strokeLinecap="round"
        strokeWidth="1.802"
        d="M21 21l-4.486-4.494L21 21zm-2-10.5a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0v0z"
      ></path>
    </svg>
  );
};
